import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  withStyles, TableContainer, TableBody,
  Table, TableRow, TableCell, Typography
} from "@material-ui/core";
import t from "../../../../../languages/pl";
import tableStyles from "./tableStyles";
import { displayDateTimeFormat } from '../../../../../utils/staticData';
import NoData from '../../../../Common/NoDataRow';
import TableHeader from '../../../../Common/TableHeader';

const tableHeaderContent = [t.date, t.content_info, t.status, t.user, t.source];

const SmsSentTable = ({ classes, smsList }) => {

  const printTable = (data) => {
    if (!Array.isArray(data) || data.length === 0)
      return <NoData colSpan={6}/>;
    let i = 0;
    return data.map(row => {
      return (
        <TableRow key={i++}>
          <TableCell align="center">
            <Typography variant="body1">
              {moment.unix(row.data).format(displayDateTimeFormat)}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body1">
              {row.zdarzenie}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body1">
              {row.status}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body1">
              {row.uzytkownik}
            </Typography>
          </TableCell>
          <TableCell align="center">
            <Typography variant="body1">
              {row.zrodlo}
            </Typography>
          </TableCell>
        </TableRow>
      );
    });
  };

  return (
    <TableContainer className={classes.container}>
      <Table stickyHeader>
        <TableHeader data={tableHeaderContent}/>
        <TableBody>
          {printTable(smsList)}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default withStyles(tableStyles)(SmsSentTable);

SmsSentTable.propTypes = {
  classes: PropTypes.object,
  smsList: PropTypes.array
};
